<script>

export default {
    name: 'Parte4'
}

</script>

<template>

    <div class="main">

        <div class="bloco1">
            <img class="logo" src="../assets/imagens/logo-simbolo.png" alt="">
            <p class="titulo">Nacional Indústria Metalúrgica Ltda</p>
            <p class="texto">Nossa equipe de profissionais altamente qualificados está comprometida em oferecer serviços
                seguros, de alta qualidade e sempre dentro dos prazos. Garantimos excelência em cada projeto e
                priorizamos a satisfação e a confiança de nossos clientes.</p>
        </div>
        <div class="bloco2">
            <div class="imagens">
                <img class="imagem" src="../assets/imagens/montagem-sitemarcelo2.png" alt="">
            </div>

        </div>

    </div>

</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100vw;
}

.bloco1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4%;
}

.bloco2 {
    width: 95%;
    margin-top: 1%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.logo {
    width: 10%;
    margin-top: 1rem;
}

.titulo {
    color: #444;
    font-weight: bold;
    font-size: 1.5rem;
    width: 95%;
    margin: 1rem 0rem;
}

.texto {
    color: #444;
    text-align: justify;
    width: 95%;
    letter-spacing: 2.5px;
    font-family: "Staatliches", sans-serif;
    font-size: 0.8rem;

}

.imagem {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 4rem;
}

.imagens {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 01%;
}
}
@media (min-width: 901px) {
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-width: 100vw;

}

.bloco1 {
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4%;
}

.bloco2 {
    width: 95%;
    height: 75%;
    margin-top: 1%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.logo {
    width: 10%;
}

.titulo {
    color: #444;
    font-weight: bold;
    font-size: 1.5rem;
    width: 25%;
}

.texto {
    color: #444;
    text-align: justify;
    width: 60%;
    letter-spacing: 2.5px;
    font-family: "Staatliches", sans-serif;

}

.imagem {
    width: 80rem;
}

.imagens {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 01%;
}
}
</style>